import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import de from './locales/de.json';
import en from './locales/en.json';
import es from './locales/es.json';
import fr from './locales/fr.json';
import it from './locales/it.json';
import ne from './locales/ne.json';

const localStorageDetector = {
  type: 'languageDetector' as const,
  async: false,
  detect: (): string => {
    const lang = localStorage.getItem('user_language') || 'en';
    console.log('[i18n] Detector - detecting language:', lang);
    return lang;
  },
  init: () => {
    console.log('[i18n] Detector - initialized');
  },
  cacheUserLanguage: (lng: string) => {
    console.log('[i18n] Detector - caching language:', lng);
    localStorage.setItem('user_language', lng);
  },
};

i18n
  .use(localStorageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: { translation: en },
      fr: { translation: fr },
      es: { translation: es },
      de: { translation: de },
      it: { translation: it },
      ne: { translation: ne },
    },
    fallbackLng: 'en',
    interpolation: {
      escapeValue: false,
    },
    react: {
      useSuspense: false,
    },
  })
  .then(() => {
    console.log('[i18n] Initialized successfully');
    console.log('[i18n] Current language:', i18n.language);
    console.log('[i18n] Loaded languages:', i18n.languages);
    console.log('[i18n] Available resources:', Object.keys(i18n.store.data));
    console.log('[i18n] Test translation (common.save):', i18n.t('common.save'));

    // Force language change if localStorage has a value different from current
    const storedLang = localStorage.getItem('user_language');
    if (storedLang && storedLang !== i18n.language) {
      console.log('[i18n] Language mismatch detected, forcing change to:', storedLang);
      i18n.changeLanguage(storedLang);
    }
  });

window.addEventListener('storage', (event) => {
  if (event.key === 'user_language' && event.newValue) {
    i18n.changeLanguage(event.newValue);
  }
});

window.addEventListener('languageChange', ((event: CustomEvent) => {
  if (event.detail && event.detail.language) {
    i18n.changeLanguage(event.detail.language);
  }
}) as EventListener);

export default i18n;
